import { action, observable } from 'mobx';

import contestStore from '@Modules/cms/stores/contests';
import postStore from '@Modules/cms/stores/post';
import config from 'config';
import { LOADING, LOADED } from 'stores/BaseStore';
import HttpClient from 'utils/httpclient';

import BaseReportStore from './base-store'

export default new class SweepWinnerStore extends BaseReportStore {
  @observable isLoading = false

  constructor() {
    super(true)
  }

  sweep = this.attachEntity(postStore, {
    params: this.postParams,
    labelKey: 'title',
    extra: ["content_type"],
    labelFn: ({ value, label, content_type }) => `[#${value}][${content_type}] - ${label}`,
  });
  contest = this.attachEntity(contestStore)

  endpointReport = 'sweep-winner'

  get postParams() {
    return {
      report: false,
      content_type: 'sweep',
    }
  }

  get winners() {
    return this.collection.data && this.collection.data.length || ''
  }

  get sweeps() {
    return this.collection.data && this.determineUniques('sweepId') || ''
  }

  get contests() {
    return this.collection.data && this.determineUniques('contestId') || ''
  }

  determineUniques(field) {
    const allCorrespondence = this.collection.data.map(item => item[field])
    const uniqueCorrespondence = new Set(allCorrespondence);
    const uniqueCorrespondenceCount = uniqueCorrespondence.size;
    return uniqueCorrespondenceCount
  }

  getCurrentSiteID() {
    const site = JSON.parse(localStorage.getItem('site'));
    return site ? site.id : 0;
  }

  @action fetchWinner(sweepContestWinnerId) {
    this.collection.readyState = LOADING;
    this.isLoading = true;

    const params = { siteId: this.getCurrentSiteID(), sweepContestWinnerId }
    const url = `sweep-winner/winner`

    return HttpClient.get(`${config.api}/${url}`, { params })
      .then(action(response => {
        this.collection.winner = response.data;
        this.collection.readyState = LOADED;
        this.isLoading = false;

        return response;
      }));
  }

  @action fetchTickets(subscriptionId) {
    this.collection.readyState = LOADING;
    this.isLoading = true;

    const params = { siteId: this.getCurrentSiteID(), subscriptionId }
    const url = `sweep-winner/tickets`
    return HttpClient.get(`${config.api}/${url}`, { params })
      .then(action(response => {
        this.collection.tickets = response.data;
        this.collection.readyState = LOADED;
        this.isLoading = false;

        return response;
      }));
  }

  @action fetchContacts(contestWinnerId) {
    this.collection.readyState = LOADING;
    this.isLoading = true;

    const params = { siteId: this.getCurrentSiteID(), contestWinnerId }
    const url = `sweep-winner/winner-contacts`
    return HttpClient.get(`${config.api}/${url}`, { params })
      .then(action(response => {
        this.collection.contacts = { data: null }
        this.collection.contacts.data = response.data;
        this.collection.contacts.contestWinnerId = contestWinnerId;
        this.collection.readyState = LOADED;
        this.isLoading = false;

        return response;
      }));
  }

  updateWinnerStatus({ sweepContestWinnerId, winnerStatus }) {
    this.collection.readyState = LOADING;
    const siteId = this.getCurrentSiteID()

    const params = { sweepContestWinnerId, winnerStatus }
    const url = `sweep-winner/${siteId}/winner-status`
    return HttpClient.post(`${config.api}/${url}`, { params })
      .then(action(response => {
        this.collection.readyState = LOADED;
        this.collection.winner = { ...this.collection.winner, winnerStatus }

        return response;
      }));
  }

  createWinnerContact({ contactType, resultType, note, sweepContestWinnerId }) {
    this.collection.readyState = LOADING;
    const siteId = this.getCurrentSiteID()

    const loggedSession = JSON.parse(localStorage.getItem('session'))
    let userData = { userId: null, userFirstName: '', userLastName: '' }
    if (loggedSession.hasOwnProperty('user')) {
      const { id, first_name, last_name } = loggedSession.user
      userData = {
        userId: id,
        userFirstName: first_name,
        userLastName: last_name,
      }
    }

    const params = { contactType, resultType, note, sweepContestWinnerId, ...userData }
    const url = `sweep-winner/${siteId}/winner-contact`
    return HttpClient.post(`${config.api}/${url}`, { params })
      .then(action(response => {
        this.collection.readyState = LOADED;
        return this.fetchContacts(sweepContestWinnerId).then(() => response)
      }));
  }

  generateNewWinner({ sweepContestWinnerId }) {
    this.collection.readyState = LOADING;

    const params = { sweepContestWinnerId }
    const url = `sweeps/new-winner`
    return HttpClient.post(`${config.api}/${url}`, { params })
      .then(action(({ data }) => {
        this.collection.readyState = LOADED;
        return data
      }));
  }
}
